export interface ModelPayerCapitalGainRealStatePayload {
  id?: number;
  modelDetailResult?: number;
  fullname?: string;
  payerNif?: string;
  physicalJuridical?: string;
  receiptModel211?: string;
  withholdings?: number;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

export function buildModelPayerCapitalGainRealStatePayload(input: any): ModelPayerCapitalGainRealStatePayload {
  const payload: ModelPayerCapitalGainRealStatePayload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const modelDetailResult = toNumber(input?.modelDetailResult);
  if (modelDetailResult !== undefined) payload.modelDetailResult = modelDetailResult;

  const fullname = toStringValue(input?.fullname);
  if (fullname !== undefined) payload.fullname = fullname;

  const payerNif = toStringValue(input?.payerNif);
  if (payerNif !== undefined) payload.payerNif = payerNif;

  const physicalJuridical = toStringValue(input?.physicalJuridical);
  if (physicalJuridical !== undefined) payload.physicalJuridical = physicalJuridical;

  const receiptModel211 = toStringValue(input?.receiptModel211);
  if (receiptModel211 !== undefined) payload.receiptModel211 = receiptModel211;

  const withholdings = toNumber(input?.withholdings);
  if (withholdings !== undefined) payload.withholdings = withholdings;

  return payload;
}
